export const GET_COMPLIANCE_ACTIONS = 'GET_COMPLIANCE_ACTIONS';
export const INITIATE_COMPLIANCE_ACTION = 'INITIATE_COMPLIANCE_ACTION';
export const SUBMIT_COMPLIANCE_ACTION_OTP = 'SUBMIT_COMPLIANCE_ACTION_OTP';
export const MARK_AS_PAID_COMPLIANCE_ACTION = 'MARK_AS_PAID_COMPLIANCE_ACTION';
